export const getMYLoanTenureYear = (manufactureYear: number) => {
  const carAge = new Date().getFullYear() - manufactureYear;
  const maxTenureYear = 15;
  const loanTenureYear = maxTenureYear - carAge;

  return loanTenureYear <= 1 ? 1 : loanTenureYear > 9 ? 9 : loanTenureYear;
};
